import * as React from 'react';
import { useFragment } from 'react-relay';
import { cutOffListDownloadFragment } from './CutOffListDownload.relay';
import type { CutOffListDownloadPropsType } from './types';

const CutOffListDownload: React.FC<CutOffListDownloadPropsType> = ( props: CutOffListDownloadPropsType ) => {
    const cutOffListDownload = useFragment( cutOffListDownloadFragment, props.cutOffListDownload );

    const link = cutOffListDownload.url + '?salesAdmission=' + props.salesAdmission;
    return (
        <a href={ link }
            className={ `${ props.className || '' } mt-[15px] inline-flex items-center text-xs text-[#636d6d] no-underline` }
        >
            {cutOffListDownload.label}
            <span className='ml-0.5 inline-block h-5 w-5 bg-[url(/static/front/assets/document-icons/xlsx.png)] bg-contain bg-no-repeat' />
        </a>
    );
};

export { CutOffListDownload };
